<template>
  <div class="vw100 h400">
    <img
      class="w-per100 h-per100"
      referrerpolicy="no-referrer"
      :src="getImageUrl(banner.image)"
      alt="佰信纸业"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  data() {
    return {
      
    }
  },
  computed: {
    ...mapGetters({
      banner:'sonBanner',
    })
  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<style scoped lang="scss">

</style>